import store from "../store";
// eslint-disable-next-line no-unused-vars
import xlooLib from "./xlooLib";
// eslint-disable-next-line no-unused-vars
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import QS from "qs";



export default {
    CreateClean: async (routeTo, routeFrom) => {
        if(
            (routeTo.name==='donateBlood' || routeTo.name==='dbChoiceDonationLocation' || routeTo.name==='dbBookingAppointment') &&
            (routeFrom.name!=='donateBlood' && routeFrom.name!=='dbChoiceDonationLocation' && routeFrom.name!=='dbBookingAppointment')
        ){
            await store.commit("donateBloodAppointments/set_constructorState")
            return
        }
        if(
            (routeFrom.name==='donateBlood' || routeFrom.name==='dbChoiceDonationLocation' || routeFrom.name==='dbBookingAppointment') &&
            (routeTo.name!=='donateBlood' && routeTo.name!=='dbChoiceDonationLocation' && routeTo.name!=='dbBookingAppointment')
        ){
            await store.commit("donateBloodAppointments/set_constructorState")
            if(!store.getters["auth/authDonor"]){
                store.commit("donorInformation/set_clearTemporaryDonorInformation")
            }
        }
    },
}